import { useEffect } from 'react';

import ToastVariant from '@lib/core/src/enums/ToastVariant';
import palette from '@lib/core/src/theme/palette';
import { alpha, Button, Stack } from '@mui/material';
import { enqueueSnackbar } from 'notistack';

import { LocalStorageKeys } from '@/enums/LocalStorageKeys';

const VERSION_CHECK_INTERVAL = 60000 * 5; // Check every 5 minutes

export const useVersionChecker = () => {
  const handleNewVersion = () => {
    enqueueSnackbar({
      variant: 'custom',
      autoHideDuration: null,
      anchorOrigin: { vertical: 'top', horizontal: 'center' },
      customProps: {
        sx: {
          borderRadius: '10px',
          backgroundColor: alpha(palette.black, 0.6),
          color: palette.white
        },
        title: 'There is a new version available.',
        caption: (
          <Stack width="100%" justifyContent="center" alignItems="center">
            <Button
              sx={{ color: palette.white, fontWeight: 600 }}
              variant="outlined"
              size="small"
              onClick={() => window.location.reload()}
            >
              {'update'}
            </Button>
          </Stack>
        ),
        variant: ToastVariant.INFO
      }
    });
  };

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch('/version.json', { cache: 'no-store' });
        const { version: latestVersion } = await response.json();

        const storedVersion = localStorage.getItem(LocalStorageKeys.APP_VERSION);
        if (storedVersion && storedVersion !== latestVersion) {
          handleNewVersion();
        }

        localStorage.setItem(LocalStorageKeys.APP_VERSION, latestVersion);
      } catch (error) {
        console.error('Error checking app version:', error);
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, VERSION_CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, []);
};
